import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { StyledTableCell } from "../common/styles";
import EmptyTableData from "../common/EmptyTableData";
import "../../index.css";
import { expenseHeaderData } from "../../utils/constants";
import ExpenseInnerRow from "./expenseInnerRow";
import { ColorPallet } from "../../utils/colorPallet";
import { CustomPagination } from "../commontable/customPagination";
import { TableCell } from "@mui/material";

interface IProps {
  expData: any;
  setReloadExpenses: any;
  page?: any;
  rowsPerPage?: any;
  totalCount?: number;
  onPageChange?: any;
  onRowsPerPageChange?: any;
  isPagination?: any;
}
const ExpenseTableRow = ({
  expData,
  setReloadExpenses,
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
  isPagination,
}: IProps) => {
  const expensesData = [...expData].sort(
    (a, b) =>
      new Date(a?.expense_date).getTime() - new Date(b?.expense_date).getTime()
  );

  return (
    <>
      <Box sx={{ mt: 3 }}>
        <TableContainer style={{ overflow: "auto",  maxHeight: "55vh",}}>
            <Table
              style={{
                border: "1px solid",
                borderColor: ColorPallet.tableHeaderColor,
              }}
            >
              <TableHead style={{ tableLayout: "fixed", width: "100%" }}>
                <TableRow>
                  {expenseHeaderData.map((header: any, index: number) => (
                    <StyledTableCell
                      key={index}
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 2,
                        color: ColorPallet.primaryGrey,
                        fontSize: "16px",
                        fontWeight: 500,
                        border: "1px solid #D3D3D3",
                      }}
                    >
                      {header}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {expData?.map((expense: any, index: number) => (
                  <ExpenseInnerRow
                    setReloadExpenses={setReloadExpenses}
                    key={index}
                    expense={expense}
                  />
                ))}
              </TableBody>
              {expData?.length > 0 && (
                <TableRow
                  sx={{
                    borderTop: `1px solid ${ColorPallet.borderColor}`,
                    borderBottom: `1px solid ${ColorPallet.borderColor}`,
                    borderRight: `1px solid ${ColorPallet.borderColor}`,
                    borderLeft: `1px solid ${ColorPallet.borderColor}`,
                  }}
                >
                  <Box
                    sx={{
                      padding: "12px",
                      fontWeight: 600,
                      fontSize: "20px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      color: "#1D1F24",
                    }}
                  >
                    Total Expense:{" "}
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: "18px",
                        lineHeight: "100%",
                        letterSpacing: "0%",
                        color: "#1D1F24",
                      }}
                    >
                      {expData?.length
                        ? expData
                            .reduce(
                              (sum: number, item: any) =>
                                sum + Number(item.amount || 0),
                              0
                            )
                            .toLocaleString()
                        : 0}{" "}
                      PKR
                    </span>
                  </Box>
                </TableRow>
              ) }
            </Table>
            {expData?.length === 0 ? (
              <EmptyTableData height="45vh" message="No Data found!" />
            ) : null}
         
        </TableContainer>
      </Box>
     
      {isPagination && expData?.length > 0 && (
        <CustomPagination
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export default ExpenseTableRow;
